export default "__VITE_ASSET__5B0gx9ss__"